export class DeviceError extends Error {
  constructor(code, message = "", ...args) {
    super(message, ...args);
    this.code = code;
    this.message = message;
  }
}
